// src/auth/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './AuthService';
import { onAuthStateChanged } from 'firebase/auth';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null); // <-- NOVO: Estado para a função
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => { // <-- Torna a função async
      if (user) {
        // Se o usuário existe, busca o token para obter as claims (funções)
        const idTokenResult = await user.getIdTokenResult();
        // Acessa a claim 'role' que definimos na Cloud Function
        setUserRole(idTokenResult.claims.role || null);
        setCurrentUser(user);
      } else {
        // Se não há usuário, limpa os estados
        setCurrentUser(null);
        setUserRole(null);
      }
      setLoadingAuth(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole, // <-- NOVO: Fornece a função para o resto do app
    loadingAuth,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loadingAuth && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
